module.exports = __webpack_public_path__ + "img/venue-4.33753837.png";